/**
 * Module dependencies.
 */

import { ReactNode } from 'react';
import { LayoutType } from 'src/types/app';

import { AuthenticationLayout } from './authentication';
import { BaseLayout } from './base';
import { CompleteSignUpLayout } from './complete-sign-up';
import { PageTransition } from './page-transition';
import { PdfLayout } from './pdf';
import { SettingsLayout } from './settings';
import { SurveyLayout } from './survey';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  layout?: LayoutType;
};

/**
 * `layouts` constant.
 */

const layouts = {
  auth: AuthenticationLayout,
  base: BaseLayout,
  completeSignUp: CompleteSignUpLayout,
  pdf: PdfLayout,
  settings: SettingsLayout,
  survey: SurveyLayout
} as const;

/**
 * Export `Layout` component.
 */

export function Layout({ children, layout = 'base' }: Props) {
  const Layout = layouts?.[layout] ?? layouts.base;

  return (
    <PageTransition>
      <Layout>{children}</Layout>
    </PageTransition>
  );
}
